// extracted by mini-css-extract-plugin
module.exports = {"selected":"_753a7a7","changeText":"_9a74e5a","withBorder":"_1aef5dc"};